import { boot } from "quasar/wrappers";
import * as Sentry from "@sentry/vue";

export default boot(({ app, router }) => {
  let environment: "dev" | "production" | "staging" = "dev";

  if (process.env.STAGING) {
    environment = "staging";
  } else if (process.env.PROD) {
    environment = "production";
  }

  Sentry.init({
    app,
    dsn: "https://5cc131ba596194b551c3f0cea1e7c715@o1278507.ingest.sentry.io/4506792305950720",
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    environment: environment,
    release: process.env.appVersion,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment === "production" ? 0.5 : 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", process.env.API!, process.env.REST_API!],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
});
